// src/components/campaign/FloatingMetric.jsx

import { motion } from "framer-motion";

export default function FloatingMetric({ label, value, className = "", delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.94 }}
      animate={{
        opacity: 1,
        y: [0, -8, 0],
        scale: 1,
      }}
      transition={{
        opacity: { delay, duration: 0.5 },
        scale: { delay, duration: 0.5 },
        y: {
          delay,
          repeat: Infinity,
          duration: 4,
          ease: "easeInOut",
        },
      }}
      className={`absolute z-20 rounded-2xl border border-white/10 bg-black/45 px-4 py-3 text-right shadow-2xl backdrop-blur-2xl ${className}`}
    >
      <div className="text-[10px] text-white/45">{label}</div>
      <div className="mt-1 whitespace-nowrap text-[12px] font-bold text-white/90">
        {value}
      </div>
    </motion.div>
  );
}